import Cookies from 'cookies-js';
import { makeUniqueId } from 'utilities/data';

export const SESSION_ID_COOKIE_NAME = 'hapyak_psid',
    THIRTY_MINUTES = 1800;

export class SessionTracker {
    constructor() {
        this.initialized = false;
    }

    initializeSession() {
        const playerSessionId = Cookies.get(SESSION_ID_COOKIE_NAME);

        if (!playerSessionId) {
            this.sessionId = makeUniqueId();
            this.extendSession(this.sessionId);
            this.initialized = true;
        } else if (!this.sessionId) {
            this.sessionId = playerSessionId;
            this.initialized = true;
        }
    }

    extendSession(id) {
        Cookies.set(SESSION_ID_COOKIE_NAME, id, { expires: THIRTY_MINUTES });
    }

    get sessionContext() {
         // to maintain pairity with the legacy implementation, we collect cookie state before initialization
        const cookieState = this.cookieState;

        if (!this.initialized) {
            this.initializeSession();
        }

        this.extendSession(this.sessionId);

        return {
            'Cookie State': cookieState,
            'Session': this.sessionId
        }
    }

    get cookieState() {
        return this.sessionId === Cookies.get(SESSION_ID_COOKIE_NAME) ? 1 : 0;
    }
}